export default {
  name: "Addendum C - Material Terms and Conditions of the Job Offer",
  symbol: "list",
  modalPrefill: {
    type: "material-terms",
    machine_name: "eta_790a_addendum_c",
    modal_name: "addProfilesModal",
    title: "Material Terms Profiles",
    allowOptionsOnlyOnce: {
      profileField: "material_terms_section_number",
      tableField: "section_number",
      profileValues: [
        "Job Duties",
        "Overtime Pay",
        "Minimum Productivity/Performance Standards",
        "Job Qualifications/Requirements",
        "Provision of Meals",
        "Daily Transportation",
        "Inbound/Outbound Transportation",
        "Deductions from Pay",
      ],
    },
    description:
      "Select the Crop/Agricultural Activity profile(s) to populate in the Addendum A table.",
  },
  pageInfo: {
    text: "<b>Important Note</b>: Information disclosed in Addendum C must NOT restate regulatory requirements, assurances, or obligations contained elsewhere on the form (e.g., assurances contained in Section I) or include statements or conditions related to the employer’s work rules, employee handbook, and other similar detailed materials, unless directly related to regulatory requirements of the H-2A program, including Agricultural Recruitment System regulations. <br/><br/> For example, detailed information an employer normally provides to worker post-hire that is not directly related to H-2A program requirements should not be included. Additional material terms and conditions of employment must comply with the requirements of the Immigration and Nationality Act and the Department's applicable regulations. Additional, separate documents are not permitted; all additional material terms and conditions of the job offer must be contained in Addendum C.",
    coloring: "grey",
    read_more: true,
    character_limit: 459,
  },
  sections: [
    {
      code: "Addendum C",
      machine_name: "eta_790a_addendum_c",
      isModal: true,
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      listType: "table",
      removeFromFieldArray: true,
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          isInlineModal: true,
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          master_fieldArray: "eta_790a_addendum_c",
          dynamicUpdates: [
            {
              set: "section_name",
              to: "Job Duties",
              if: "Job Duties",
            },
            {
              set: "section_name",
              to: "Overtime Pay",
              if: "Overtime Pay",
            },
            {
              set: "section_name",
              to: "Minimum Productivity/Performance Standards",
              if: "Minimum Productivity/Performance Standards",
            },
            {
              set: "section_name",
              to: "Job Qualifications/Requirements",
              if: "Job Qualifications/Requirements",
            },
            {
              set: "section_name",
              to: "Provision of Meals",
              if: "Provision of Meals",
            },
            {
              set: "section_name",
              to: "Daily Transportation",
              if: "Daily Transportation",
            },
            {
              set: "section_name",
              to: "Inbound/Outbound Transportation",
              if: "Inbound/Outbound Transportation",
            },
            {
              set: "section_name",
              to: "Deductions from Pay",
              if: "Deductions from Pay",
            },
            {
              set: "section_name",
              to: null,
              if: "Other Material Terms and Conditions",
            },
          ],
          allowOptionsOnlyOnce: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
          ],
          validate: ["required"],
          tooltip: `Select the Form ETA-790A Section name associated with the additional information to be disclosed.
          <br>
          <br>
          For electronic and mailed or paper filings, the filing system will ONLY accept the following valid section name entries: 
          <br>
          <ul>
            <li>Job Duties</li>
            <li>Overtime Pay</li>
            <li>Minimum Productivity/Performance Standards</li>
            <li>Job Qualifications/Requirements</li>
            <li>Provision of Meals</li>
            <li>Daily Transportation</li>
            <li>Inbound/Outbound Transportation</li>
            <li>Deductions from Pay</li>
            <li>Other Material Terms and Conditions.</li>
          </ul>
          `,
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          isVisible: {
            when: "section_number",
            is: ["Other Material Terms and Conditions", "- Select -"],
            operator: "!==",
            prefix: "add_values_field",
          },
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          isVisible: {
            when: "section_number",
            is: "Other Material Terms and Conditions",
            prefix: "add_values_field",
          },
          hideOnTable: true,
          widget: "text",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          hideOnTable: true,
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
          tooltip:
            "Enter the additional information to be disclosed related to Items 1 and 2 above.  The space in this field will permit the entry of up to 5,000 characters. ",
        },
      ],
    },
  ],
};
